
// import { FC, useContext, useEffect, useState } from "react"
// import { DownloadReportsResponseTypeApi, StatsReportProps } from "./types";
// import useFetch from "src/hooks/useFetch";
// // import { DownloadZipErrorType } from "src/pages/dashboard/types";
// // import { ToastTypes } from "src/types";
// import { APIEndpoints } from "src/types/apiTypes";
// // import { useNavigate } from "react-router-dom";
// import { AuthContext } from "src/context/authContext";
// import { LoaderContext } from "src/context/loaderContext";
// // import { ToastContext } from "src/context/toastContext";
// import { downloadExcelFile } from "src/helpers/downloadFile";

// const StatsReports: FC<StatsReportProps> = ({ getValues }): JSX.Element => {

//   const [enabledButton, setEnabledButton] = useState<boolean>(false);
//   const { userData, report_listing } = useContext(AuthContext)
//   // const { showToast } = useContext(ToastContext);
//   const { setLoader, hideLoader } = useContext(LoaderContext);
//   // const navigate = useNavigate();




//   const {
//     loading: downloadReportsLoading,
//     data: downloadReportsData, error: downloadReportsError, mutate: downloadRequestForm,
//     removeErrorAndData: clearRequestFileData
//   } = useFetch<DownloadReportsResponseTypeApi>(APIEndpoints.MANUFACTURE_STATISTICS_REPORT_DOWNLOAD);

//   useEffect(() => {
//     if (downloadReportsData || downloadReportsError) {
//       if (downloadReportsData) {
//         const { response, report_name } = downloadReportsData;
//         downloadExcelFile(response, `${report_name}.xlsx`);
//       }
//       // hideLoader();
//       setEnabledButton(false);

//     }

//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [downloadReportsData, downloadReportsError]);


//   const DownloadReport = (reportName: string) => {
//     if (getValues) {
//       let params = {
//         'start_date': getValues().start_date,
//         'end_date': getValues().end_date,
//         'report_name': reportName,
//         ...(reportName === "full_report" || reportName === "refill_report" || reportName === "condensed_sales_report" ? { view: "full_report" } : {}),
//         ...(userData && userData.ref_type === "rep" ? { user_id: userData.id } : {})
//       }
//       if (downloadReportsData || downloadReportsError) clearRequestFileData();
//       //setLoader();
//       setEnabledButton(true)
//       console.log("Params for download report API: ", params)
//       downloadRequestForm({}, {}, params);
//     }
//   }

//   return (
//      <></>
//     // <div className="row g-2 reports-btn">
//     //   {downloadReportsLoading ? (
//     //     <div className="col">
//     //       <p className="text-dark h5">
//     //         <span className="spinner-border spinner-border-sm" style={{ width: 20, height: 20 }} aria-hidden="true"></span>{' '}
//     //         <i>Fetching Report</i>
//     //       </p>
//     //     </div>
//     //   ) : ( userData && userData.email !== "devh@elusahealth.com" &&
//     //     <>
//     //       {report_listing && report_listing["Full Report"] ? (
//     //         <div className="col">
//     //           <button className="btn btn-success w-100" onClick={() => {
//     //             DownloadReport("full_report")
//     //           }} disabled={enabledButton}>
//     //             Full Report
//     //           </button>
//     //         </div>
//     //       ) : null}

//     //       {report_listing && report_listing["Status Report"] ? (
//     //         <div className="col">
//     //           <button className="btn btn-success w-100" onClick={() => {
//     //             DownloadReport("status_report")
//     //           }} disabled={enabledButton}>
//     //             Status Report
//     //           </button>
//     //         </div>
//     //       ) : null}

//     //       {report_listing && report_listing["Incoming Fax Report"] ? (
//     //         <div className="col">
//     //           <button className="btn btn-success w-100" onClick={() => {
//     //             DownloadReport("incoming_fax_report")
//     //           }} disabled={enabledButton}>
//     //             Incoming Fax Report
//     //           </button>
//     //         </div>
//     //       ) : null}

//     //       {report_listing && report_listing["Field Liaison Report"] ? (
//     //         <div className="col">
//     //           <button className="btn btn-success w-100" onClick={() => {
//     //             DownloadReport("field_liaison_report")
//     //           }} disabled={enabledButton}>
//     //             Field Liaison Report
//     //           </button>
//     //         </div>
//     //       ) : null}

//     //       {report_listing && report_listing["Refill Report"] && userData && userData.ref_type === "Manufacturer" ? (
//     //         <div className="col">
//     //           <button className="btn btn-success w-100" onClick={() => {
//     //             DownloadReport("refill_report")
//     //           }} disabled={enabledButton}>
//     //             Refill Report
//     //           </button>
//     //         </div>
//     //       ) : null}
//     //       {report_listing && report_listing["Condensed Sales Report"] ? (
//     //         <div className="col">
//     //           <button className="btn btn-success w-100" onClick={() => {
//     //             DownloadReport("condensed_sales_report")
//     //           }} disabled={enabledButton}>
//     //             Condensed Sales Report
//     //           </button>
//     //         </div>
//     //       ) : null}
//     //     </>
//     //   )}

//   //     {/* {report_listing && report_listing["Incoming Fax Report"] ? (
//   //       <div className="col">
//   //         <button className="btn btn-success w-100" onClick={() => {
//   //           DownloadReport("incoming_fax_report")
//   //         }} disabled={enabledButton}>
//   //           Incoming Fax Report
//   //         </button>
//   //       </div>
//   //     ) : null}

//   //     {report_listing && report_listing["Pre Condensed Sales Report"] ? (
//   //       <div className="col">
//   //         <button className="btn btn-success w-100" onClick={() => {
//   //           DownloadReport("condensed_sales_report")
//   //         }} disabled={enabledButton}>
//   //           Condensed Sales Report
//   //         </button>
//   //       </div>
//   //     ) : null} */}
//   //  // </div>
//   );
// };

// export default StatsReports;



import { FC, useContext, useEffect, useState } from "react"
import { DownloadReportsResponseTypeApi, StatsReportProps } from "./types";
import useFetch from "src/hooks/useFetch";
// import { DownloadZipErrorType } from "src/pages/dashboard/types";
// import { ToastTypes } from "src/types";
import { APIEndpoints } from "src/types/apiTypes";
// import { useNavigate } from "react-router-dom";
import { AuthContext } from "src/context/authContext";
import { LoaderContext } from "src/context/loaderContext";
// import { ToastContext } from "src/context/toastContext";
import { downloadExcelFile } from "src/helpers/downloadFile";

const StatsReports: FC<StatsReportProps> = ({ getValues }): JSX.Element => {

  const [enabledButton, setEnabledButton] = useState<boolean>(false);
  const { userData, report_listing } = useContext(AuthContext)
  // const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);
  // const navigate = useNavigate();




  const {
    loading: downloadReportsLoading,
    data: downloadReportsData, error: downloadReportsError, mutate: downloadRequestForm,
    removeErrorAndData: clearRequestFileData
  } = useFetch<DownloadReportsResponseTypeApi>(APIEndpoints.MANUFACTURE_STATISTICS_REPORT_DOWNLOAD);

  useEffect(() => {
    if (downloadReportsData || downloadReportsError) {
      if (downloadReportsData) {
        const { response, report_name } = downloadReportsData;
        downloadExcelFile(response, `${report_name}.xlsx`);
      }
      // hideLoader();
      setEnabledButton(false);

    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downloadReportsData, downloadReportsError]);


  const DownloadReport = (reportName: string) => {
    if (getValues) {
      let params = {
        'start_date': getValues().start_date,
        'end_date': getValues().end_date,
        'report_name': reportName,
        ...(reportName === "full_report" || reportName === "refill_report" || reportName === "condensed_sales_report" ? { view: "full_report" } : {}),
        ...(userData && userData.ref_type === "rep" ? { user_id: userData.id } : {})
      }
      if (downloadReportsData || downloadReportsError) clearRequestFileData();
      //setLoader();
      setEnabledButton(true)
      console.log("Params for download report API: ", params)
      downloadRequestForm({}, {}, params);
    }
  }

  return (

    (process.env.REACT_APP_ENV === "production" ?
      <div className="row g-2 reports-btn">
        {downloadReportsLoading ? (
          <div className="col">
            <p className="text-dark h5">
              <span className="spinner-border spinner-border-sm" style={{ width: 20, height: 20 }} aria-hidden="true"></span>{' '}
              <i>Fetching Report</i>
            </p>
          </div>
        ) : (
          <div className="row p-4">
            {report_listing && report_listing["Full Report"] ? (
              <div className="col">
                <button className="btn btn-success w-100" onClick={() => {
                  DownloadReport("full_report")
                }} disabled={enabledButton}>
                  Full Report
                </button>
              </div>
            ) : null}

            {report_listing && report_listing["Status Report"] ? (
              <div className="col">
                <button className="btn btn-success w-100" onClick={() => {
                  DownloadReport("status_report")
                }} disabled={enabledButton}>
                  Status Report
                </button>
              </div>
            ) : null}

            {report_listing && report_listing["Incoming Fax Report"] ? (
              <div className="col">
                <button className="btn btn-success w-100" onClick={() => {
                  DownloadReport("incoming_fax_report")
                }} disabled={enabledButton}>
                  Incoming Fax Report
                </button>
              </div>
            ) : null}

            {report_listing && report_listing["Field Liaison Report"] ? (
              <div className="col">
                <button className="btn btn-success w-100" onClick={() => {
                  DownloadReport("field_liaison_report")
                }} disabled={enabledButton}>
                  Field Liaison Report
                </button>
              </div>
            ) : null}

            {report_listing && report_listing["Refill Report"] && userData && userData.ref_type === "Manufacturer" ? (
              <div className="col">
                <button className="btn btn-success w-100" onClick={() => {
                  DownloadReport("refill_report")
                }} disabled={enabledButton}>
                  Refill Report
                </button>
              </div>
            ) : null}
            {report_listing && report_listing["Condensed Sales Report"] ? (
              <div className="col">
                <button className="btn btn-success w-100" onClick={() => {
                  DownloadReport("condensed_sales_report")
                }} disabled={enabledButton}>
                  Condensed Sales Report
                </button>
              </div>
            ) : null}
          </div>
        )}
      </div> : <></>)

  );
};

export default StatsReports;